import { useRouter } from "next/router"
import { Fields } from "@common/v2/form/types"
import Form, { Submit } from "@common/v2/form"
import DefaultLayout from "@common/v2/form/layouts/default"
import Link from "next/link"
import { FormState } from "@common/forms/types"
import { NetworkResponse } from "@common/types"
import { Header } from "@common/header/headerUnit"

let fields: Fields = {
  password: {
    element: "input",
    type: "password",
    label: {
      label: "Password",
    },
    validation: {
      required: true,
      minLength: 4,
    },
  },
  confirm_password: {
    element: "input",
    type: "password",
    label: {
      label: "Confirm Password",
    },
    validation: {
      minLength: 4,
      required: true,
    },
  },
}

export default function ResetPasswordForm({
  token,
  submitFunction,
}: {
  token: string
  submitFunction?: (state: FormState) => Promise<NetworkResponse>
}) {
  const router = useRouter()
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-lg">
      <div className="bg-background text-foreground p-10 border sm:rounded-lg sm:px-14">
        <div className="my-2">
          <Header.MainHeader variant="h6" alignment="center">
            <p className="mb-6">Reset your Password</p>
          </Header.MainHeader>
        </div>
        <Form
          fields={fields}
          submitFunction={submitFunction}
          initialFormState={{ token }}
          onSubmitSuccess={() => router.push("/login?reset=true")}
        >
          <DefaultLayout />
          <Submit>Update Password</Submit>
          <p className="py-4">
            <Link href="/login" className="link-blue">
              Back to login
            </Link>
          </p>
        </Form>
      </div>
    </div>
  )
}
